import { useMutation, useQuery } from '@tanstack/react-query'

import { useAddNotification } from 'hooks/useAddNotification'
import { billingSummaryFromServer } from 'models/campaign-payment-model'
import { del, get } from 'utils/http'

// Billing summary; both payment cards call with the same id so TanStack dedupes to one request.
export const useCampaignBilling = (id: any) =>
  useQuery({
    queryKey: ['campaignBilling', id],
    queryFn: async () => billingSummaryFromServer(await get(`/management/campaigns/${id}/billing`)),
    enabled: !!id,
  })

// Fire-and-forget delete (no invalidate, matching the old thunk); surface an error toast since it's destructive.
export const useDeleteCampaignSubscription = () => {
  const addNotification = useAddNotification()
  return useMutation({
    mutationFn: (id: any) => del(`/management/campaigns/${id}`),
    onError: () => addNotification('Error occurred when deleting subscription', 'error'),
  })
}
